import Modal, { ModalProps } from "../Modal/Modal";
import { useTranslation } from "react-i18next";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import Textfield from "../Input/Textfield";
import Button from "../Button/Button";
import { InternalMessageType } from "@/shared/utils/enum";
import useInternalNotificationsReplyPost from "@/shared/mutations/internalNotifications/useInternalNotificationsReplyPost";
import { useForm } from "react-hook-form";
import ModalTitle from "../Modal/ModalTitle";

const InternalNotificationReplyModal = ({ ...props }: ModalProps) => {
  const { t } = useTranslation("");
  const [{ id, type }] = useModalMeta();
  const setModal = useSetModal();
  const { register, handleSubmit, errors } = useForm();
  const { replyAppsmen, replyCustomer } = useInternalNotificationsReplyPost();

  const onSubmit = ({ reply }) => {
    const replyToCustomer = InternalMessageType.CUSTOMER_MESSAGE === type;

    if (replyToCustomer) {
      replyCustomer.mutateAsync(
        { itemId: id, message: reply },
        { onSuccess: () => setModal("", {}) }
      );
    } else {
      replyAppsmen.mutateAsync(
        { message: reply },
        { onSuccess: () => setModal("", {}) }
      );
    }
  };

  return (
    <Modal onExit={() => setModal("")} {...props}>
      <ModalTitle>{t("notifications.writeYourResponse")}</ModalTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Textfield
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          rows="3"
          as="textarea"
          name="reply"
          error={errors?.reply?.message}
        />

        <div className="mt-2 flex justify-end gap-4">
          <Button
            onClick={() => setModal("", {})}
            variant="secondary"
            type="button"
          >
            {t("close")}
          </Button>
          <Button isPending={replyCustomer.isPending || replyAppsmen.isPending}>
            {t("send")}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default InternalNotificationReplyModal;
